// Never points back at an auth page and never nests a `redirect=` — that is the runaway
// /login?redirect=%2Flogin%3Fredirect%3D… accumulation, since the 401 handler folds the whole current URL in.
// undefined when there is no meaningful destination, so callers can omit the param rather than point it at /login.
const AUTH_PATH_SUFFIXES = ['/login', '/register']

export function resolveRedirectTarget(candidate: string | null | undefined): string | undefined {
  let target = candidate ?? ''
  // Normal flows resolve in one step; the bound only guards a pathological hand-crafted URL.
  for (let depth = 0; depth < 25; depth++) {
    if (!target) return undefined
    const queryStart = target.indexOf('?')
    const path = queryStart === -1 ? target : target.slice(0, queryStart)
    if (!AUTH_PATH_SUFFIXES.some((suffix) => path.endsWith(suffix))) return target
    // URLSearchParams.get decodes exactly one layer of percent-encoding, peeling off one nesting level.
    const query = queryStart === -1 ? '' : target.slice(queryStart + 1)
    const inner = new URLSearchParams(query).get('redirect')
    if (!inner) return undefined
    target = inner
  }
  return undefined
}
